import { ExtensionInterface } from 'probonio-shared-ui/registry/extension-definition';
import { ReactNode } from 'react';

export abstract class RoutesExtensionInterface extends ExtensionInterface {
  /**
   * @description Should return one or more <Route /> Components
   * @example
   * ```tsx
   * <>
   *     <Route path="/myPath" component={<MyComponent />} />
   * </>
   * ``` */
  abstract get routes(): ReactNode;
}
